{
  "useInheritedPermissions": "Use permissões herdadas de {{ resource }}",
  "permissions": "permissões",
  "addUserOrGroup": "Adicionar usuário ou grupo",
  "additionalPermissions": "Permissões adicionais",
  "inheritedPermissions": "Permissões herdadas",
  "turnOffInheritance": "Desativar a herança",
  "turnOnInheritance": "Ativar herança",
  "turnOnInheritanceDescription1": "Ao ativar isso, você restabelecerá as permissões herdadas do pai.",
  "turnOnInheritanceDescription2": "Observe que, ao ativá-la novamente, todas as permissões adicionais sobre esse item serão perdidas.",
  "turnOffInheritanceDescription1": "Ao desativar isso, você poderá ajustar as permissões de todos os usuários e grupos de usuários.",
  "turnOffInheritanceDescription2": "Observe que, ao quebrar a cadeia de herança, quaisquer alterações futuras feitas nas permissões do pai não serão passadas para esse item.",
  "inheritanceChangesSaved": "As alterações de herança são salvas automaticamente.",
  "authLevels": {
    "admin": {
      "title": "Acesso total",
      "descriptionPlan": "Edite, acesse, exclua, renomeie e gerencie permissões",
      "descriptionFolder": "Crie, renomeie e exclua planos e pastas",
      "descriptionLayer": "Edite, acesse, exclua, renomeie e gerencie permissões"
    },
    "write": {
      "title": "Editar",
      "descriptionPlan": "Crie e edite objetos e atributos",
      "descriptionFolder": "Pode adicionar planos e subpastas",
      "descriptionLayer": "Crie e edite objetos e atributos"
    },
    "read": {
      "title": "Visualizar",
      "descriptionPlan": "Pode visualizar o plano e adicionar comentários",
      "descriptionFolder": "Pode visualizar o conteúdo da pasta",
      "descriptionLayer": "Pode visualizar os objetos pertencentes a essa camada"
    },
    "deny": {
      "title": "Sem acesso",
      "descriptionPlan": "Não é possível visualizar o plano",
      "descriptionFolder": "Não é possível visualizar o conteúdo da pasta",
      "descriptionLayer": "Não é possível visualizar objetos pertencentes a essa camada"
    }
  },
  "usersGroups": {
    "searchLabel": "Insira um nome ou grupo",
    "searchTitle": "Procure um colega"
  },
  "permissionsEditTitle": "Definir {{ nodeType }} Permissões de edição",
  "resourceLockDescription1": "As permissões estão bloqueadas e ninguém pode fazer edições.",
  "resourceLockDescription2": "Os administradores podem desbloquear a qualquer momento.",
  "unlockButtonText": "Desbloqueie para permitir a edição",
  "inheritedLockDescription1": "Ninguém pode fazer edições devido a um bloqueio em cascata de um pai.",
  "inheritedLockDescription2": "Os administradores podem desbloquear acessando as configurações dos pais.",
  "lock": "Bloquear",
  "inheritedPermissionsHelpText": "Com essa configuração ativada, esse objeto usará as permissões definidas pelo objeto pai.",
  "linkExpiredModal": {
    "title": "Link expirado",
    "content": "Esse link expirou ou é inválido.\n Entre em contato com o usuário que criou o link se precisar de acesso."
  },
  "copyPermissions": "Permissões de cópia"
}